module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }